import { render, staticRenderFns } from "./ShowToca.vue?vue&type=template&id=7d812f67&"
import script from "./ShowToca.vue?vue&type=script&lang=js&"
export * from "./ShowToca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports